import { render, staticRenderFns } from "./ImsRejectedTrades.vue?vue&type=template&id=b4226618&"
import script from "./ImsRejectedTrades.vue?vue&type=script&lang=js&"
export * from "./ImsRejectedTrades.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports